import { render, staticRenderFns } from "./PromotionFooter.vue?vue&type=template&id=0c926db0&scoped=true&"
import script from "./PromotionFooter.vue?vue&type=script&lang=ts&"
export * from "./PromotionFooter.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionFooter.vue?vue&type=style&index=0&id=0c926db0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c926db0",
  null
  
)

export default component.exports